import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'townip-messages-header',
  templateUrl: './messages-header.component.html',
  styleUrls: ['./messages-header.component.scss']
})
export class MessagesHeaderComponent implements OnInit {

  constructor() { }

  public ngOnInit(): void {
  }

}
